import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { UsersApiClient } from "@/Service/Api/V1/ApiClients/UsersApiClient";
import { QueryKeys } from "@/Service/Api/V1/QueryKeys/QueryKeys";
import { GetUsersRequest } from "@/Stub/V1";

export type useGetUsersParams = {
    requestParams?: GetUsersRequest
    enabled?: boolean
    savePreviousData?: boolean
};

export const useGetUsers = ({ requestParams, enabled, savePreviousData }: useGetUsersParams = {}) => useQuery({
    ...QueryKeys.users.list(requestParams),
    queryFn: async () => await UsersApiClient.getUsers(requestParams),
    enabled,
    gcTime: 0,
    placeholderData: savePreviousData ? keepPreviousData : undefined
});